// Tracks the previously visited pathname, app-wide.
//
// React Router doesn't expose "where did I come from", and several screens need it: the ticket
// listing only restores its saved page/tab when the user is returning from a ticket's details
// page, not when they arrive from the sidebar or Lodge a Complaint.
//
// Module state rather than React state on purpose — it must survive component remounts, including
// StrictMode's deliberate double-mount in development.

let previousPath = "";
let currentPath = "";

// Called on every route change (see RouteHistoryTracker in Router.tsx). Repeated calls with the
// same path are ignored, so StrictMode's double-invoked effects don't shift the history.
export const recordVisitedPath = (path: string): void => {
  if (path === currentPath) return;
  previousPath = currentPath;
  currentPath = path;
};

export const getPreviousPath = (): string => previousPath;

export const cameFrom = (pathPrefix: string): boolean =>
  !!pathPrefix && previousPath.startsWith(pathPrefix);
